module.exports = __webpack_public_path__ + "media/honey-icons/icon-service-status-12cf274e.svg";